import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';
import BorrowerReligiousMembersServedRuleset from '../../business/ruleset/BorrowerReligiousMembersServedRuleset';

const { borrowerReligiousMembersServed } = loanFormModel.formField;

export class BorrowerReligiousMembersServedValidation
  implements ValidationSchema
{
  public name = borrowerReligiousMembersServed.name;
  public label = borrowerReligiousMembersServed.label;
  public type = 'number';

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
  public ruleset = BorrowerReligiousMembersServedRuleset;

  public when(schema: Yup.NumberSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(new BorrowerReligiousMembersServedValidation());
